export default "__VITE_ASSET__4d5da397__"